import {
  CONTACT_LIST_FETCH,
  CONTACT_LIST_SUCCESS,
  CONTACT_LIST_FAILURE
} from './actionTypes';

//import { ADD_CONTACT_TO_THE_LIST } from '../ServiceForm/actionTypes';

const initialState = {
  isLoaded: false,
  contacts: [],
  error: []
};

export const contactsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONTACT_LIST_FETCH:
      return { ...state, isLoaded: false };
    case CONTACT_LIST_SUCCESS:
      return { ...state, isLoaded: true, contacts: action.payload };
    /*     case ADD_CONTACT_TO_THE_LIST:
      return {
        ...state,
        isLoaded: true,
        contacts: [...state.contacts, action.payload]
      }; */
    case CONTACT_LIST_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};

export const isLoaded = state => state.contactList.isLoaded;
export const getContacts = state => state.contactList.contacts;
export const getError = state => state.contactList.error;



// WEBPACK FOOTER //
// ./src/modules/ContactList/reducer.js